import type { ReactNode } from "react";

type AdminDetailSectionLayoutProps = {
  actions: ReactNode;
  children: ReactNode;
  errorMessage: null | string;
  eyebrow: string;
  title: string;
};

export const AdminDetailSectionLayout = ({
  actions,
  children,
  errorMessage,
  eyebrow,
  title,
}: AdminDetailSectionLayoutProps) => {
  return (
    <div className="admin-detail-pane">
      <header className="admin-detail-header">
        <div>
          <p className="admin-detail-eyebrow">{eyebrow}</p>
          <h2 className="admin-detail-title">{title}</h2>
        </div>
        <div className="admin-detail-actions">{actions}</div>
      </header>
      {errorMessage ? <div className="admin-detail-state is-error">{errorMessage}</div> : null}
      {children}
    </div>
  );
};
